import { render, staticRenderFns } from "./ListagemRelatorioRastreabilidade.vue?vue&type=template&id=b27f21ea&scoped=true&lang=pug"
import script from "./ListagemRelatorioRastreabilidade.vue?vue&type=script&lang=js"
export * from "./ListagemRelatorioRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./ListagemRelatorioRastreabilidade.vue?vue&type=style&index=0&id=b27f21ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27f21ea",
  null
  
)

export default component.exports